<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">

        <v-toolbar :extension-height="$vuetify.breakpoint.lgAndDown ? 150 : 62"
                   fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Confirm Procurement Position {{selectedProcurementPosition.id}} -
                {{selectedProcurementPosition.purchase_orders_position.purchase_order.customer_purchase_order_number}}
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-layout row wrap slot="extension">

                <v-flex xs12 lg12>
                    <v-layout>
                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-text-field
                                    label="Position-ID"
                                    :value="selectedProcurementPosition.id"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md2 pl-4 pa-2>
                            <v-text-field
                                    label="Manufacturer"
                                    :value="selectedProcurementPosition.purchase_orders_position.product.manufacturer.name"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md3 pl-4 pa-2>
                            <v-text-field
                                    label="Item-Number"
                                    :value="selectedProcurementPosition.purchase_orders_position.product.reference"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-text-field
                                    label="Quantity"
                                    :value="selectedProcurementPosition.purchase_orders_position.quantity"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-text-field
                                    label="Unit"
                                    :value="selectedProcurementPosition.purchase_orders_position.unit.code"
                                    readonly
                            ></v-text-field>
                        </v-flex>


                        <v-flex sm12 md3 pl-4 pa-2>
                            <v-text-field
                                    :suffix="selectedProcurementPosition.purchase_orders_position.purchase_order.currency.name"
                                    label="Total Prov"
                                    :value="calculateTotalProv.price"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md3 pl-4 pa-2>
                            <v-text-field
                                    suffix="%"
                                    label="Total Prov"
                                    :value="calculateTotalProv.percent"
                                    readonly
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                </v-flex>

            </v-layout>

        </v-toolbar>

        <div v-show="$vuetify.breakpoint.lgAndDown" style="height: 96px"></div>

        <v-container fluid grid-list-md pt-5>

            <v-data-iterator v-if="!loadingSupplierOfferPositions"
                             :items="getSupplierOfferPositions"
                             :rows-per-page-items="rowsPerPageItems"
                             :pagination.sync="pagination"
                             content-tag="v-layout"
                             row
                             wrap
                             pt-5
            >

                <v-flex pt-5
                        slot="item"
                        slot-scope="props"
                        xs12
                        sm6
                        md3
                        lg2
                >
                    <v-hover>
                        <v-card @click.native="setSelectedSupplierOffer(props.item)" slot-scope="{ hover }"
                                :class="`elevation-${hover ? 4 : 1}`">
                            <v-card-title>
                                <v-menu
                                        transition="slide-y-transition"
                                        :nudge-bottom="20"
                                        :nudge-right="0"
                                        :nudge-left="0">
                                    <v-btn small @click="openBottomSheet($vuetify.breakpoint.mdAndDown)"
                                           id="menu-button"
                                           slot="activator"
                                           icon>

                                        <v-icon dark>more_vert</v-icon>
                                    </v-btn>
                                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                                        <v-list-tile @click.native="editSupplierOffer()">
                                            <v-list-tile-title>
                                                <v-icon color="primary">edit</v-icon>
                                            </v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile @click.native="deleteSupplierOffer()">
                                            <v-list-tile-title>
                                                <v-icon color="red">delete</v-icon>
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                                <h4>{{ props.item.suppliers_offer.supplier.name }}</h4>
                                <v-spacer></v-spacer>
                                <v-icon v-if="selectedProcurementPosition.suppliers_offers_positions_id === props.item.id"
                                        color="success">
                                    check_circle
                                </v-icon>
                            </v-card-title>
                            <v-divider></v-divider>
                            <!--      <v-list dense>-->
                            <v-list dense>
                                <v-list-tile>
                                    <v-list-tile-content>Unit Price:</v-list-tile-content>
                                    <v-list-tile-content
                                            v-if="selectedProcurementPosition.suppliers_offers_positions_id === props.item.id"
                                            class="align-end"><b>
                                        {{calculateSupplierOfferUnitPriceMethod(props.item) }}
                                        {{props.item.suppliers_offer.currency.name }}</b>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else class="align-end">
                                        {{calculateSupplierOfferUnitPriceMethod(props.item) }}
                                        {{props.item.suppliers_offer.currency.name }}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>Delivery Time:</v-list-tile-content>
                                    <v-list-tile-content
                                            v-if="selectedProcurementPosition.suppliers_offers_positions_id === props.item.id"
                                            class="align-end"><b>{{ props.item.delivery_time.value }} {{
                                        props.item.delivery_time.delivery_times_type.name }}</b>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else class="align-end">{{ props.item.delivery_time.value }}
                                        {{
                                        props.item.delivery_time.delivery_times_type.name }}
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-list-tile>
                                    <v-list-tile-content>Payment Term:</v-list-tile-content>
                                    <v-list-tile-content
                                            v-if="selectedProcurementPosition.suppliers_offers_positions_id === props.item.id"
                                            class="align-end"><b>{{
                                        props.item.suppliers_offer.terms_of_payment.description }}</b>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else class="align-end">{{
                                        props.item.suppliers_offer.terms_of_payment.description }}
                                    </v-list-tile-content>
                                </v-list-tile>


                                <v-list-tile>
                                    <v-list-tile-content>Valid Until:</v-list-tile-content>
                                    <v-list-tile-content
                                            v-if="selectedProcurementPosition.suppliers_offers_positions_id === props.item.id"
                                            class="align-end"><b>{{
                                        props.item.suppliers_offer.valid_until | toDateOnly }}</b>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else class="align-end">{{
                                        props.item.suppliers_offer.valid_until | toDateOnly }}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>Supplier Offer:</v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        <v-btn flat fab small class="pdfbutton"
                                               :loading="getLoadingDocumentToken(props.item.suppliers_offer.id)"
                                               @click="generateDocumentToken(props.item.suppliers_offer)"
                                        >
                                            <v-icon
                                                    size="20" color="secondary"

                                            >fal fa-file-pdf
                                            </v-icon>
                                        </v-btn>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-card>

                    </v-hover>
                </v-flex>
                <template v-slot:footer>
                    <v-toolbar flat>
                        <v-toolbar-title></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon color="secondary darken-1"
                               @click.native="openAddSupplierDialog()">
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-toolbar>
                </template>
            </v-data-iterator>

            <v-container v-if="loadingSupplierOfferPositions"
                         pt-5>
                <v-layout row wrap align-center
                          pt-5>
                    <v-flex class="text-xs-center">
                        <v-progress-circular
                                :size="60"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-container>

        <v-layout row wrap>
            <v-flex pl-4 pr-4>

                <v-layout row wrap>
                    <v-flex xs12 md4 pl-4 pt-4 pa-2>
                        <v-card>
                            <v-card-title><h4>Descriptions / Remark</h4></v-card-title>
                            <v-divider></v-divider>
                            <v-layout row wrap pt-4>
                                <v-flex xs12 pl-4 pr-4>
                                    <v-textarea
                                            :value="selectedProcurementPosition.purchase_orders_position.product.product_description.description"
                                            auto-grow
                                            label="Product Description"
                                            readonly
                                    ></v-textarea>
                                </v-flex>
                                <v-flex xs12 pl-4 pr-4>
                                    <v-textarea
                                            auto-grow
                                            rows="4"
                                            label="Order Confirmation Description"
                                            readonly
                                            v-model="selectedProcurementPosition.purchase_orders_position.description"
                                    ></v-textarea>
                                </v-flex>
                                <v-flex xs12 pl-4 pr-4>
                                    <v-textarea
                                            auto-grow
                                            rows="4"
                                            label="Order Confirmation Remark"
                                            readonly
                                            v-model="selectedProcurementPosition.purchase_orders_position.remark"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 md8 pl-4 pt-4 pa-2 pb-5>
                        <v-card>
                            <v-card-title><h4>Confirm Procurement Position Values</h4></v-card-title>
                            <v-divider></v-divider>


                            <v-layout row wrap pt-4 pr-4 pl-4 pb-5>

                                <v-flex xs12 pt-2 pl-4 pr-4>
                                    <v-layout wrap>
                                        <v-subheader>Unit Prov</v-subheader>
                                        <v-spacer></v-spacer>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 pb-4 pl-4 pr-4>
                                    <v-divider></v-divider>
                                </v-flex>


                                <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field
                                            :suffix="selectedSupplierOfferPosition.suppliers_offer.currency.name"
                                            label="Purchase Unit-Price"
                                            :value="calculateSupplierOfferUnitPriceFormatted"
                                            readonly
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field v-if="needExchange"
                                                  :suffix="selectedProcurementPosition.purchase_orders_position.purchase_order.currency.name"
                                                  label="Exchange Rate"
                                                  :value="getExchangeRate"
                                                  readonly
                                                  :loading="loading"
                                                  type="number"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field v-if="needExchange"
                                                  :suffix="selectedProcurementPosition.purchase_orders_position.purchase_order.currency.name"
                                                  label="Purchase Unit-Price Exchange"
                                                  :value="calculateExchangePurchasePrice"
                                                  readonly
                                                  :loading="loading"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field
                                            :suffix="selectedProcurementPosition.purchase_orders_position.purchase_order.currency.name"
                                            label="Unit Sales Price"
                                            :value="selectedProcurementPosition.purchase_orders_position.unit_sales_price | toMoney"
                                            readonly
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field
                                            :suffix="selectedProcurementPosition.purchase_orders_position.purchase_order.currency.name"
                                            label="Unit-Prov"
                                            :value="calculateUnitProv.price"
                                            readonly
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field
                                            suffix="%"
                                            label="Unit-Prov %"
                                            :value="calculateUnitProv.percent"
                                            readonly
                                    ></v-text-field>
                                </v-flex>


                                <v-flex xs12 pt-2 pl-4 pr-4>
                                    <v-layout wrap>
                                        <v-subheader>Total Prov</v-subheader>
                                        <v-spacer></v-spacer>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 pb-4 pl-4 pr-4>
                                    <v-divider></v-divider>
                                </v-flex>

                                <v-flex xs12 md2 pl-4 pr-4>
                                    <v-text-field
                                            label="Quantity"
                                            :value="selectedProcurementPosition.purchase_orders_position.quantity"
                                            readonly
                                            type="number"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md1 pl-4 pr-4>
                                    <v-text-field
                                            label="Unit"
                                            :value="selectedProcurementPosition.purchase_orders_position.unit.code"
                                            readonly
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md3 pl-4 pr-4>
                                    <v-text-field
                                            :suffix="selectedProcurementPosition.purchase_orders_position.purchase_order.currency.name"
                                            label="Total Sales Price"
                                            :value="selectedProcurementPosition.purchase_orders_position.total_sales_price | toMoney"
                                            readonly
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md3 pl-4 pr-4>
                                    <v-text-field
                                            :suffix="selectedProcurementPosition.purchase_orders_position.purchase_order.currency.name"
                                            label="Total Prov"
                                            :value="calculateTotalProv.price"
                                            readonly
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md3 pl-4 pr-4>
                                    <v-text-field
                                            suffix="%"
                                            label="Total Prov"
                                            :value="calculateTotalProv.percent"
                                            readonly
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>


                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn :loading="loading" color="secondary"
                                       @click.native="confirmProcurementPosition()">
                                    CONFIRM
                                    PROCUREMENT POSITION
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>

            </v-flex>

        </v-layout>

        <AddSupplierDialog></AddSupplierDialog>

    </v-card>

</template>

<script>
    import {
        Settings,
        SupplierOfferPositions,
        SupplierOffers,
        Procurement,
        ProcurementPosition
    } from '../../../store/namespace-helper'

    import DocumentTokenChip from '../../Shared/DocumentTokenChip.vue'
    import DatetimePicker from '../../Shared/DatetimePicker.vue'
    import {in$, $} from 'moneysafe'
    import {$$, subtractPercent} from 'moneysafe/ledger'
    import {VMoney} from 'v-money'
    import {dateFunctionFilters} from '../../../mixins/dateFunctionFilters'
    import {numberFormatFilters} from '../../../mixins/numberFormatFilters'
    import AddSupplierDialog from '../../SupplierOffers/AddSupplierOfferDialog.vue'

    import {API_URL} from '../../../store/index'

    export default {
      components: {
        AddSupplierDialog,
        DatetimePicker,
        DocumentTokenChip
      },
      mixins: [dateFunctionFilters, numberFormatFilters],
      name: 'ConfirmOrderPosition',
      data () {
        return {
          isVisible: false,
          rowsPerPageItems: [6, 8, 12],
          pagination: {
            rowsPerPage: 6
          },
          discountTypes: ['percent'],
          additionalCostTypes: ['percent', 'fixed'],
          allAccounts: [],
          loadingOfferForId: false,
          money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: true /* doesn't work with directive */
          },
          unitOrderSalesPrice: null
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadCurrencies()
              this.loadUnits()
              this.loadTermsOfDeliveries()
              this.loadTermsOfPayments()
              this.loadSupplierOffers()
              this.loadDeliveryTimeTypes()
              this.loadAllAccounts()
              this.initUnitSalesPrice()
            } else {

            }
          }
        },
        closeDialog () {
          this.$store.dispatch(ProcurementPosition.actions.setSelectedProcurementPosition, null)
          this.$store.dispatch(SupplierOfferPositions.actions.setSelectedSupplierOfferPosition, null)
          this.$store.dispatch(SupplierOffers.actions.setSelectedSupplierOffer, null)
          this.$store.dispatch(ProcurementPosition.actions.openCloseDialog)
        },
        loadCurrencies () {
          this.$store.dispatch(Settings.actions.loadAllCurrencies)
        },
        loadUnits () {
          this.$store.dispatch(Settings.actions.loadAllUnits)
        },
        loadTermsOfPayments () {
          this.$store.dispatch(Settings.actions.loadTermsOfPayments)
        },
        loadTermsOfDeliveries () {
          this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
        },
        loadSupplierOffers () {
          this.$store.dispatch(SupplierOfferPositions.actions.loadSupplierOfferPositionByProductID, this.selectedProcurementPosition.purchase_orders_position.products_id).then(response => {
            console.log('suppliers_offers_positions_id: ' + this.selectedProcurementPosition.suppliers_offers_positions_id)
            let item = response.data.data.find(x => x.id === this.selectedProcurementPosition.suppliers_offers_positions_id)
            if (item !== null) {
              this.setSelectedSupplierOffer(item)
            }
          })
        },
        loadDeliveryTimeTypes () {
          this.$store.dispatch(Settings.actions.loadAllDeliveryTimeTypes)
        },
        confirmProcurementPosition () {
          let confirmItem = {
            id: this.selectedProcurementPosition.id,
            suppliers_offers_positions_id: this.selectedProcurementPosition.suppliers_offers_positions_id
          }
          this.$store.dispatch(ProcurementPosition.actions.confirmProcurementPosition, confirmItem).then(response => {
            this.closeDialog()
          })
        },
        loadAllAccounts () {
          this.$store.dispatch(Settings.actions.loadAllAccounts).then(response => {
            this.allAccounts = response.data.data
          })
        },
        initUnitSalesPrice () {
          var element = document.getElementById('unitOrderSalesPrice')
          var event = new Event('input')
          if (typeof element !== 'undefined' && element !== null) {
            element.value = ''
            element.dispatchEvent(event)
            element.value = new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format('0.00')
            element.dispatchEvent(event)
          }
        },
        customContactFilter (item, queryText, itemText) {
          const isMatch = (test, query) => {
            return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
          }
          const query = queryText || ''
          const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
          const rc = isMatch(item.firstname, query) ||
                    isMatch(item.lastname, query) ||
                    isMatch(item.email, query) ||
                    isMatch(displayText, query)
          console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
          return rc
        },
        setSelectedSupplierOffer (item) {
          this.$store.dispatch(SupplierOffers.actions.setSelectedSupplierOffer, item.suppliers_offer)
          this.$store.dispatch(SupplierOfferPositions.actions.setSelectedSupplierOfferPosition, item)
          this.selectedProcurementPosition.suppliers_offers_positions_id = item.id
          this.loadCurrencyExchangeRate()
        },
        openAddSupplierDialog () {
          this.$store.dispatch(SupplierOffers.actions.setSelectedSupplierOffer, null)
          this.$store.dispatch(SupplierOffers.actions.openCloseDialog)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        },
        editSupplierOffer () {
          this.$store.dispatch(SupplierOffers.actions.openCloseDialog)
        },
        deleteSupplierOffer () {

        },
        getPDF () {
          let link = document.createElement('a')

          link.href = API_URL + '/documentStore/' + this.getDocumentViewToken.token
          link.target = '_blank'
          link.rel = 'noopener noreferrer'
          link.click()
        },
        generateDocumentToken (supplierOffer) {
          this.loadingOfferForId = supplierOffer.id
          this.$store.dispatch(SupplierOffers.actions.getDocumentViewTokenBySupplierOfferId, {
            id: supplierOffer.id,
            filename: supplierOffer.offer_number + '.pdf'
          }).then(response => {
            this.getPDF()
            this.loadingOfferForId = false
          })
        },
        getLoadingDocumentToken (val) {
          return this.loadingOfferForId === val
        },
        calculateSupplierOfferUnitPriceMethod (val) {
          var unitPrice = val.unit_price
          val.discounts.forEach(function (item) {
            unitPrice -= (unitPrice * (item.value / 100))
          })
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(unitPrice)
        },
        loadCurrencyExchangeRate () {
          this.$store.dispatch(Settings.actions.loadExchangeRate, this.selectedSupplierOfferPosition.suppliers_offer.currency.name)
        }
      },
      computed: {
        selectedItem () {
          console.log('selected procurement: ' + JSON.stringify(this.$store.getters[Procurement.getters.getSelectedProcurement]))
          return this.$store.getters[Procurement.getters.getSelectedProcurement]
        },
        selectedProcurementPosition () {
          console.log('selected procurement position: ' + JSON.stringify(this.$store.getters[ProcurementPosition.getters.getSelectedProcurementPosition]))
          return this.$store.getters[ProcurementPosition.getters.getSelectedProcurementPosition]
        },
        selectedSupplierOfferPosition () {
          return this.$store.getters[SupplierOfferPositions.getters.getSelectedSupplierOfferPosition]
        },
        getDocumentViewToken () {
          return this.$store.getters[SupplierOffers.getters.getSupplierOfferDocumentToken]
        },
        calculatedTotalSalesPrice () {
          this.selectedOrderPosition.total_sales_price = this.selectedOrderPosition.quantity * this.selectedOrderPosition.unit_sales_price
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.selectedOrderPosition.quantity * this.selectedOrderPosition.unit_sales_price)
        },
        getUnits () {
          return this.$store.getters[Settings.getters.getAllUnits]
        },
        getSupplierOfferPositions () {
          return this.$store.getters[SupplierOfferPositions.getters.getSupplierOfferPositions]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        loadingSupplierOfferPositions () {
          return this.$store.getters[SupplierOfferPositions.getters.getLoadingSupplierOfferPosition]
        },
        getCurrencies () {
          return this.$store.getters[Settings.getters.getAllCurrencies]
        },
        termsOfPayment () {
          return this.$store.getters[Settings.getters.getTermsOfPayments]
        },
        termsOfDelivery () {
          return this.$store.getters[Settings.getters.getTermsOfDeliveries]
        },
        getExchangeRate () {
          if (this.selectedProcurementPosition.purchase_orders_position.purchase_order.currency.name !== null || typeof this.selectedProcurementPosition.purchase_orders_position.purchase_order.currency.name === 'undefined') {
            let currency = this.selectedProcurementPosition.purchase_orders_position.purchase_order.currency.name
            return this.$store.getters[Settings.getters.getExchangeRate].quotes['USD' + currency]
          }
          return 0.00
        },
        getDeliveryTimeTypes () {
          return this.$store.getters[Settings.getters.getAllDeliveryTimeTypes]
        },
        calculateSupplierOfferUnitSalesPriceFormatted () {
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.calculateSupplierOfferUnitSalesPrice)
        },
        calculateSupplierOfferUnitPriceFormatted () {
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.calculateSupplierOfferUnitPrice)
        },
        calculateCustomersOfferUnitPriceFormatted () {
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.selectedOrderPosition.customers_offers_position.unit_sales_price)
        },
        calculateSupplierOfferUnitPrice () {
          var unitPrice = this.selectedSupplierOfferPosition.unit_price
          this.selectedSupplierOfferPosition.discounts.forEach(function (item) {
            unitPrice = $$(
                        $(unitPrice),
                        subtractPercent(item.value)
                    ).$
          })
          return unitPrice
        },
        supplierOfferDialog () {
          return this.$store.getters[SupplierOffers.getters.getOpenDialogState]
        },
        needExchange () {
          if (this.selectedProcurementPosition.purchase_orders_position.purchase_order.currency.id !== this.selectedSupplierOfferPosition.suppliers_offer.currency.id) {
            return true
          } else {
            return false
          }
        },
        calculateExchangePurchasePrice () {
          if (this.calculateSupplierOfferUnitPrice !== 0 && this.getExchangeRate !== 0) {
            return new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format(in$($(this.calculateSupplierOfferUnitPrice) * this.getExchangeRate))
          } else {
            return '0,00'
          }
        },
        calculateUnitProv () {
          var prov = {
            percent: 0,
            price: 0
          }

          if (this.needExchange) {
            prov.price = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format($$(
                        $(this.selectedProcurementPosition.purchase_orders_position.unit_sales_price),
                        $(-in$($(this.calculateSupplierOfferUnitPrice * this.getExchangeRate)))
                    ).$)

            prov.percent = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(((
                $$(
                    $(this.selectedProcurementPosition.purchase_orders_position.unit_sales_price),
                    $(-in$($(this.calculateSupplierOfferUnitPrice * this.getExchangeRate)))
                ).$ / this.selectedProcurementPosition.purchase_orders_position.unit_sales_price)) * 100)

            return prov
          } else {
            prov.price = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format($$(
                        $(this.selectedProcurementPosition.purchase_orders_position.unit_sales_price),
                        $(-this.calculateSupplierOfferUnitPrice)
                    ).$)

            prov.percent = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format((($$(
                $(this.selectedProcurementPosition.purchase_orders_position.unit_sales_price),
                $(-this.calculateSupplierOfferUnitPrice)
            ).$ / this.selectedProcurementPosition.purchase_orders_position.unit_sales_price)) * 100)

            return prov
          }
        },
        calculateTotalProv () {
          var prov = {
            percent: 0,
            price: 0
          }

          if (this.needExchange) {
            prov.price = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format($$(
                        $(this.selectedProcurementPosition.purchase_orders_position.unit_sales_price * this.selectedProcurementPosition.purchase_orders_position.quantity),
                        $(-in$($((this.calculateSupplierOfferUnitPrice * this.selectedProcurementPosition.purchase_orders_position.quantity) * this.getExchangeRate)))
                    ).$)

            prov.percent = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format((($$(
                $(this.selectedProcurementPosition.purchase_orders_position.unit_sales_price * this.selectedProcurementPosition.purchase_orders_position.quantity),
                $(-in$($((this.calculateSupplierOfferUnitPrice * this.selectedProcurementPosition.purchase_orders_position.quantity) * this.getExchangeRate)))
            ).$ / (this.selectedProcurementPosition.purchase_orders_position.unit_sales_price * this.selectedProcurementPosition.purchase_orders_position.quantity))) * 100)

            return prov
          } else {
            prov.price = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format($$(
                        $((this.selectedProcurementPosition.purchase_orders_position.unit_sales_price * this.selectedProcurementPosition.purchase_orders_position.quantity)),
                        $(-(this.calculateSupplierOfferUnitPrice * this.selectedProcurementPosition.purchase_orders_position.quantity))
                    ).$)

            prov.percent = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(($$(
                $((this.selectedProcurementPosition.purchase_orders_position.unit_sales_price * this.selectedProcurementPosition.purchase_orders_position.quantity)),
                $(-(this.calculateSupplierOfferUnitPrice * this.selectedProcurementPosition.purchase_orders_position.quantity))
            ).$ / ((this.selectedProcurementPosition.purchase_orders_position.unit_sales_price * this.selectedProcurementPosition.purchase_orders_position.quantity))) * 100)

            return prov
          }
        }
      },
      watch: {
        unitOrderSalesPrice: {
          handler (val) {
            if (val !== null) {
              console.log('confirmUnitSalesPrice: ' + val)
              var formatRemoved = val.replace(/\./g, '')
              formatRemoved = formatRemoved.replace(/,/g, '.')
              this.selectedOrderPosition.unit_sales_price = formatRemoved
            }
          }
        },
        supplierOfferDialog: {
          handler (val) {
            if (!val) {
              this.loadSupplierOffers()
            }
          },
          deep: true
        }

      },
      directives: {money: VMoney}

    }
</script>


<style scoped>

    #menu-button {
        margin: 0px;
        margin-right: 8px;
        width: 25px;
        height: 25px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: #1e336d;
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .overflow-hidden {
        overflow: hidden;
    }

    .horiz-scroll {
        overflow-y: hidden;
        overflow-x: auto;
    }

    .pdfbutton {
        margin-right: 0px;
    }


</style>



// WEBPACK FOOTER //
// src/components/Procurements/ProcurementPositions/ConfirmProcurementPosition.vue